import { Api } from 'models/services/api';
import { UpdateUserQuery } from 'models/services/graphql';

import { UserEditorDataToUpdate } from '../editor';
import { UserDataToRevise } from '../index';

type DataToUpdate = {
  id: string;
  input: UserEditorDataToUpdate;
};

const RequestQuery = `
  mutation UpdateUser($id: ID!, $input: UpdateUserInput!) {
    ${UpdateUserQuery}
  }
`;

type ResponseData = {
  data: {
    updateUser: UserDataToRevise;
  };
};

class UpdateGql {

  readonly api: Api<ResponseData>;
  readonly document?: UserDataToRevise;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToUpdate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.updateUser;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { UpdateGql };